module.exports = __webpack_public_path__ + "img/Slide_2.60c769ca.jpg";